import { Box, Typography } from '@mui/material';
import zeplinColor from '../../../../../../theme/Color';

export const TimeAxisColumn = ({
  timeSlot,
}: {
  timeSlot: {
    time: string;
    hour24: string;
    hourIndex: number;
  };
}) => {
  const timeColumnWidth = 150;

  return (
    <Box
      sx={{
        width: `${timeColumnWidth}px`,
        minWidth: `${timeColumnWidth}px`,
        borderRight: `1px solid ${zeplinColor.Neutral5}`,
        backgroundColor: zeplinColor.Neutral1,
        display: 'flex',
        justifyContent: 'center',
        padding: { xs: '10px 10px 10px 10px', xl: '16px 16px 16px 16px' },
        position: 'sticky',
        left: 0,
        zIndex: 100,
      }}
    >
      <Box
        sx={{
          padding: { xs: '0px 8px 12px 8px', xl: '0px 8px 24px 8px' },
        }}
      >
        <Typography
          variant='body2'
          sx={{
            color: zeplinColor.Neutral8,
            marginTop: '-10px',
            fontWeight: 500,
          }}
        >
          {timeSlot.time}
        </Typography>
      </Box>
    </Box>
  );
};
